import { Context, createContext, FunctionComponent, JSX, useContext } from 'react'
import { createPortal } from 'react-dom'
import styles from './dialogHeader.module.scss'
import { Typography } from '@mui/material'

interface DialogHeaderProps {
    title?: string
    className?: string
    parent?: boolean
    variant?:
        | 'inherit'
        | 'h1'
        | 'h2'
        | 'h3'
        | 'h4'
        | 'h5'
        | 'h6'
        | 'subtitle1'
        | 'subtitle2'
        | 'body1'
        | 'body2'
        | 'caption'
        | 'button'
        | 'overline'
}

export const DialogHeaderTarget: Context<HTMLDivElement | null> = createContext<HTMLDivElement | null>(null)

const DialogHeader: FunctionComponent<DialogHeaderProps> = ({
    title,
    className,
    parent = false,
    variant = 'h5'
}: DialogHeaderProps) => {
    const target: HTMLDivElement | null = useContext(DialogHeaderTarget)
    const header: JSX.Element = (
        <div className={`${parent ? styles.ParentRoot : styles.DaycareRoot} ${className}`}>
            <Typography variant={variant} className={styles.Title}>
                {title}
            </Typography>
        </div>
    )

    return target ? createPortal(header, target) : header
}

export default DialogHeader
